import styled from 'styled-components';
import { getSize } from '../../hooks';
import { SecondaryButton } from './secondary-button';
export var AssignmentActionButton = styled(SecondaryButton).withConfig({
  displayName: "assignment-action-button__AssignmentActionButton",
  componentId: "sc-z05x3j-0"
})(["width:100%;justify-content:center;padding-left:", ";padding-right:", ";font-size:", ";"], getSize('padding8'), getSize('padding8'), getSize('typo13'));